import { Box, Flex, Stack, Table, Text } from '@mantine/core';

type NewDialogsRowProps = {
  page: string;
  count: number;
  indicator: string | null;
  color?: string;
  pageName?: string;
};

export const NewDialogsRow = ({ page, count, indicator, color, pageName }: NewDialogsRowProps) => {
  const indicatorColor = indicator === '↑' ? 'green' : 'red';

  return (
    <Table.Tr>
      <Table.Td>{indicator && <Text c={indicatorColor}>{indicator}</Text>}</Table.Td>

      <Table.Td>
        <Flex align="center" gap={6}>
          <Box style={{ width: 10, height: 10, borderRadius: 5, background: color ?? 'gray' }} />
          <Stack>
            {pageName ? <Text>{pageName}</Text> : <Text c="dimmed">Unknown</Text>}
            <Text>({page})</Text>
          </Stack>
        </Flex>
      </Table.Td>

      <Table.Td>{count}</Table.Td>
    </Table.Tr>
  );
};
